import type { APlusData, APlusItems } from '../types';

export const getInitialAplusData = (items: APlusItems) => {
  const data: APlusData = new Map();

  items.forEach((item) => {
    data.set(item.uuid, {
      item,
      selected: Boolean(item.preselected || item.mandatory),
      value: item.serviceCount?.current,
    });
  });

  return data;
};
